/* Automatically generated file, do not update manually */
export default {
  KredlyLens: {},
  PoolLens: {
    4477: '0xed0eED79889a3d3f7c6292047d5D865e0bB12874',
  },
  PoolRegistry: {
    4477: '0xF27Fde577cEDacE265eDcA081Dd6C1ef80d0a83b',
  },
  LegacyPoolComptroller: {},
  VaiController: {},
  VaiVault: {},
  XvsTokenMultichain: {},
  XvsVault: {},
  XvsStore: {},
  GovernorBravoDelegate: {
    56: '0x0000000000000000000000000000000000000000',
    97: '0x0000000000000000000000000000000000000000',
  },
  XvsVesting: {
    56: '0x0000000000000000000000000000000000000000',
    97: '0x0000000000000000000000000000000000000000',
  },
  VrtConverter: {
    56: '0x0000000000000000000000000000000000000000',
    97: '0x0000000000000000000000000000000000000000',
  },
  Maximillion: {
    56: '0x5efA1e46F4Fd738FF721F5AebC895b970F13E8A1',
    97: '0xF3a34e06015e019D6154a0f1089f695B27122f50',
  },
  XsequenceMulticall: {
    1: '0xd130B43062D875a4B7aF3f8fc036Bc6e9D3E1B3E',
    56: '0xd130B43062D875a4B7aF3f8fc036Bc6e9D3E1B3E',
    97: '0xd130B43062D875a4B7aF3f8fc036Bc6e9D3E1B3E',
    204: '0x3E5f527Adf40B65Fcbb4918e6507ecB89AF7Cdf5',
    4477: '0xB99B02cAfb8Ee9314519a0037299fe4ff4E91a30',
    5003: '0x2f536ab5b6213f8ba8aE6C3C509EDDf82c234519',
    5611: '0x2f536ab5b6213f8ba8aE6C3C509EDDf82c234519',
    11155111: '0xd130B43062D875a4B7aF3f8fc036Bc6e9D3E1B3E',
  },
  Multicall3: {
    56: '0xca11bde05977b3631167028862be2a173976ca11',
    97: '0xca11bde05977b3631167028862be2a173976ca11',
    204: '0xca11bde05977b3631167028862be2a173976ca11',
    4477: '0xca11bde05977b3631167028862be2a173976ca11',
    5003: '0xca11bde05977b3631167028862be2a173976ca11',
    5611: '0xca11bde05977b3631167028862be2a173976ca11',
    11155111: '0xca11bde05977b3631167028862be2a173976ca11',
  },
  ResilientOracle: {
    4477: '0xb8Fcc3573D9A0D9c8dd3F4Cf1a1D0fB418888fCA',
    5003: '0xb8Fcc3573D9A0D9c8dd3F4Cf1a1D0fB418888fCA',
  },
  Prime: {},
  VTreasury: {},
  VTreasuryV8: {},
  XVSProxyOFTDest: {},
  XVSProxyOFTSrc: {},
  SwapRouter: {
    1: {},
    56: {},
    97: {},
    204: {},
    4477: {},
    5003: {},
    5611: {},
    11155111: {},
  },
  NativeTokenGateway: {
    1: {},
    56: {},
    97: {},
    204: {},
    4477: {},
    5611: {},
    11155111: {},
  },
};
